module.exports = __webpack_public_path__ + "static/media/elearning.5a90cb87.jpg";